import React from 'react'
import ConditionTwoButtonsModal from './ConditionTwoButtonsModal'
import YesItsPerfectComponentWrapper from './YesItsPerfectComponentWrapper'
import { ContactPageNumber } from '../../constants'
import { pageObject } from '../../constants/pageObject'
import useEventBus from '../generic/useEventBus'

export default ({ showModal, nextClick, onCloseModal, addImpressions, updateGlobalState, tab, urlState, isOfferCreationComponentEnabled = false }) => {
  const onClickPositive = () => {
    urlState['noDamageModal'] = true
    !isOfferCreationComponentEnabled && updateGlobalState({ fireAnalytics: 'sm_skip_to_next_steps_modal_btn', cp: pageObject[tab] })
    nextClick(ContactPageNumber)
  }
  const onClickNegative = () => {
    const analytics = []
    addImpressions && addImpressions(analytics)
    !isOfferCreationComponentEnabled && updateGlobalState({ fireAnalytics: 'sm_return_to_questionnaire_btn', cp: pageObject[tab] })
    onCloseModal()
  }

  if (isOfferCreationComponentEnabled) {
    useEventBus('YesItsPerfectModalYesClicked', _ => onClickPositive())

    useEventBus('YesItsPerfectModalClosed', _ => onClickNegative())
  }

  const showConditionModal = () => {
    return (
      (showModal === true || showModal === false) && (
        <div>
          <ConditionTwoButtonsModal
            name={'NoDamageIndicatorModal'}
            testId={`vc-no-damage-modal`}
            positiveCopyOverride={"Yes! It's Perfect"}
            onClickPositive={() => onClickPositive()}
            negativeCopyOverride={'Return to Questionnaire'}
            onClickNegative={() => onClickNegative()}
            title={'Is Your Vehicle Really Free from Damage, Wear or Problems?'}
            open={showModal}
            minHeight={'100px'}
            closeOnClickOutside={false}></ConditionTwoButtonsModal>
        </div>
      )
    )
  }

  const showConditionWebComponent = () => {
    return showModal === true && <YesItsPerfectComponentWrapper></YesItsPerfectComponentWrapper>
  }

  return isOfferCreationComponentEnabled ? showConditionWebComponent() : showConditionModal()
}
